import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CampaignRegionsEntity } from '../../domain/entities/CampaignRegionsEntity'

export class CampaignRegionsModel extends CampaignRegionsEntity {
  regionId?: number | null

  constructor(dataDto: CampaignRegionsEntity) {
    super()
    mapEntityProperties<CampaignRegionsModel>(this, dataDto, {
      exclude: ['region', 'districts'],
      map: {
        regionId: dataDto.region?.id,
        districtIds: dataDto.districts?.map((district) => district.id)
      }
    })
  }
}
